import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useOrders } from '../contexts/OrderContext';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Truck, MapPin, Package, ArrowRight } from 'lucide-react';
import { StatusBadge } from '../components/ui/StatusBadge';
export function DriverDashboard() {
  const {
    user
  } = useAuth();
  const {
    orders,
    tours
  } = useOrders();
  const navigate = useNavigate();
  // Orders waiting for collection (Status: CREEE)
  // Ideally filtered by zone or assignment, but for MVP showing all CREEE orders
  const ordersToCollect = orders.filter(o => o.status === 'CREEE');
  // Filter for driver's active tours (Deliveries)
  const myDeliveryTours = tours.filter(t => t.driverId === user?.id && t.status === 'EN_COURS' && t.type === 'LIVRAISON');
  return <div className="space-y-8" data-id="element-417">
      <div className="flex justify-between items-center" data-id="element-418">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-419">
          Bonjour, {user?.name}
        </h1>
      </div>

      {/* Collection Section */}
      <div data-id="element-420">
        <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-421">
          <Package className="w-5 h-5 mr-2 text-blue-600" data-id="element-422" />
          Commandes à Collecter ({ordersToCollect.length})
        </h2>

        {ordersToCollect.length === 0 ? <Card className="bg-gray-50 border-dashed" data-id="element-423">
            <div className="text-center py-8 text-gray-500" data-id="element-424">
              Aucune commande en attente de collecte.
            </div>
          </Card> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-425">
            {ordersToCollect.map(order => <Card key={order.id} className="border-l-4 border-l-blue-500 hover:shadow-md transition-shadow" data-id="element-426">
                <div className="flex justify-between items-start mb-3" data-id="element-427">
                  <div data-id="element-428">
                    <h3 className="font-bold text-gray-900" data-id="element-429">
                      {order.clientName}
                    </h3>
                    <div className="text-sm text-gray-500 flex items-center mt-1" data-id="element-430">
                      <MapPin className="w-3 h-3 mr-1" data-id="element-431" />
                      {order.address}
                    </div>
                    <div className="text-xs font-semibold text-blue-600 mt-1 bg-blue-50 inline-block px-2 py-0.5 rounded" data-id="element-432">
                      {order.zone}
                    </div>
                  </div>
                  <div className="text-right" data-id="element-433">
                    <span className="text-lg font-bold text-gray-900" data-id="element-434">
                      {order.quantity}
                    </span>
                    <div className="text-xs text-gray-500" data-id="element-435">{order.type}</div>
                  </div>
                </div>

                <div className="mt-4 pt-3 border-t border-gray-100 flex justify-between items-center" data-id="element-436">
                  <div className="text-xs text-gray-400" data-id="element-437">
                    {new Date(order.createdAt).toLocaleDateString('fr-FR')}
                  </div>
                  <Button size="sm" onClick={() => navigate(`/orders/${order.id}/collect`)} className="bg-blue-600 hover:bg-blue-700" data-id="element-438">
                    Confirmer Collecte <ArrowRight className="w-3 h-3 ml-1" data-id="element-439" />
                  </Button>
                </div>
              </Card>)}
          </div>}
      </div>

      {/* Delivery Tours Section */}
      <div data-id="element-440">
        <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center" data-id="element-441">
          <Truck className="w-5 h-5 mr-2 text-green-600" data-id="element-442" />
          Mes Tournées de Livraison
        </h2>
        {myDeliveryTours.length === 0 ? <Card className="bg-gray-50 border-dashed" data-id="element-443">
            <div className="text-center py-6 text-gray-500" data-id="element-444">
              Aucune tournée de livraison assignée.
            </div>
          </Card> : <div className="space-y-4" data-id="element-445">
            {myDeliveryTours.map(tour => <Card key={tour.id} className="border-l-4 border-l-green-500" data-id="element-446">
                <div className="flex justify-between items-start mb-4" data-id="element-447">
                  <div data-id="element-448">
                    <span className="inline-block px-2 py-1 text-xs font-bold rounded mb-2 bg-green-100 text-green-800" data-id="element-449">
                      LIVRAISON
                    </span>
                    <h3 className="font-bold text-lg" data-id="element-450">{tour.zone}</h3>
                    <p className="text-sm text-gray-500" data-id="element-451">
                      {tour.orderIds.length} commandes à livrer
                    </p>
                  </div>
                  <Button size="sm" onClick={() => navigate(`/driver/tours/${tour.id}`)} data-id="element-452">
                    Démarrer
                  </Button>
                </div>
              </Card>)}
          </div>}
      </div>
    </div>;
}